import React from 'react';

interface FormGroupProps {
  children?: React.ReactNode;
  md?: number;
  lg?: number;
}

const FormGroup: React.FC<FormGroupProps> = ({
  children,
  md,
  lg
}) => {
  return (
    <div
      className={[
        'mz-form-group',
        md ? `col-md-${md}` : '',
        lg ? `col-lg-${lg}` : '',
      ].join(' ')}
    >
      {children}
    </div>
  );
};

export default FormGroup;
